import classNames from 'classnames'
import { forwardRef } from 'react'
import { type ButtonProps } from './Button.types'
import { Spinner } from './Spinner'

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { children, active, className, loading, variant = 'outline', ...rest } = props
  const isOutline = variant === 'outline'
  const isPrimary = variant === 'primary'

  return (
    <button
      {...rest}
      ref={ref}
      className={classNames(
        'relative rounded px-4 font-semibold shadow-sm outline-none transition enabled:cursor-pointer hover:enabled:opacity-70 enabled:active:opacity-100',
        {
          'border border-solid bg-white hover:enabled:border-blue-500 hover:enabled:text-blue-500': isOutline,
        },
        {
          'enabled:border-stone-300 enabled:text-gray-800': isOutline && !active,
        },
        {
          'enabled:border-blue-500 enabled:text-blue-500': isOutline && active,
        },
        { 'enabled:bg-blue-600': isPrimary && active },
        {
          'border-0 enabled:bg-blue-500 enabled:text-white enabled:active:bg-blue-600': isPrimary,
        },
        'disabled:cursor-not-allowed disabled:border disabled:border-solid disabled:border-gray-200 disabled:text-gray-400',
        className,
      )}
    >
      <div className="flex h-full items-center justify-center gap-1">
        {loading && (
          <span className="animate-spin">
            <Spinner />
          </span>
        )}
        {children}
      </div>
    </button>
  )
})

Button.displayName = 'Button'
